/**
 * Wishlist functionality
 * Stores wishlist items in localStorage
 */

(function() {
  // Only initialize once
  if (window.Wishlist) {
    return;
  }

  class Wishlist {
    constructor() {
      this.storageKey = 'shopify_wishlist';
      this.init();
    }

    init() {
      // Initialize wishlist buttons
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.updateAllButtons();
          this.updateBubble();
          this.attachEventListeners();
        });
      } else {
        this.updateAllButtons();
        this.updateBubble();
        this.attachEventListeners();
      }
    }

    attachEventListeners() {
      // Use event delegation instead of direct listeners
      document.body.addEventListener('click', (e) => {
        const button = e.target.closest('.product-wishlist-btn');
        if (button) {
          e.preventDefault();
          e.stopPropagation();
          this.toggleWishlist(button);
        }
      });
    }

    getWishlist() {
      try {
        const wishlist = localStorage.getItem(this.storageKey);
        return wishlist ? JSON.parse(wishlist) : [];
      } catch (e) {
        console.error('Error reading wishlist:', e);
        return [];
      }
    }

    saveWishlist(wishlist) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
        this.updateBubble();
        this.dispatchWishlistEvent();
      } catch (e) {
        console.error('Error saving wishlist:', e);
      }
    }

    isInWishlist(productId) {
      const wishlist = this.getWishlist();
      return wishlist.some(item => item.id === productId);
    }

    addToWishlist(productData) {
      const wishlist = this.getWishlist();

      if (!this.isInWishlist(productData.id)) {
        wishlist.push(productData);
        this.saveWishlist(wishlist);
        return true;
      }

      return false;
    }

    removeFromWishlist(productId) {
      let wishlist = this.getWishlist();
      wishlist = wishlist.filter(item => item.id !== productId);
      this.saveWishlist(wishlist);
    }

    toggleWishlist(button) {
      const productId = button.dataset.productId;
      const productData = {
        id: productId,
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
        image: button.dataset.productImage,
        price: button.dataset.productPrice
      };

      if (this.isInWishlist(productId)) {
        this.removeFromWishlist(productId);
        button.classList.remove('is-active');
        this.showNotification('Verwijderd van wishlist');
      } else {
        this.addToWishlist(productData);
        button.classList.add('is-active');
        this.showNotification('Toegevoegd aan wishlist');
      }

      this.updateAllButtons();
    }

    updateAllButtons() {
      const buttons = document.querySelectorAll('.product-wishlist-btn');

      buttons.forEach(button => {
        const productId = button.dataset.productId;
        if (this.isInWishlist(productId)) {
          button.classList.add('is-active');
        } else {
          button.classList.remove('is-active');
        }
      });
    }

    // Header: teller-bubble bijwerken en het hartje rood kleuren zodra
    // er iets in de wishlist zit.
    updateBubble() {
      const count = this.getCount();

      document.querySelectorAll('[data-wishlist-bubble]').forEach(bubble => {
        bubble.classList.toggle('visually-hidden', count === 0);
      });

      document.querySelectorAll('[data-wishlist-count]').forEach(el => {
        el.textContent = count;
        el.classList.toggle('hidden', count === 0);
      });

      document.querySelectorAll('[data-wishlist-count-text]').forEach(el => {
        el.textContent = count;
      });

      document.querySelectorAll('.action__wishlist').forEach(link => {
        link.classList.toggle('wishlist-has-items', count > 0);
      });
    }

    showNotification(message) {
      // Remove existing notification
      const existingNotification = document.querySelector('.wishlist-notification');
      if (existingNotification) {
        existingNotification.remove();
      }

      // Create notification
      const notification = document.createElement('div');
      notification.className = 'wishlist-notification';
      notification.textContent = message;
      document.body.appendChild(notification);

      // Trigger animation
      setTimeout(() => {
        notification.classList.add('show');
      }, 10);

      // Remove after 3 seconds
      setTimeout(() => {
        notification.classList.remove('show');
        setTimeout(() => {
          notification.remove();
        }, 300);
      }, 3000);
    }

    dispatchWishlistEvent() {
      const event = new CustomEvent('wishlist:updated', {
        detail: { wishlist: this.getWishlist() }
      });
      document.dispatchEvent(event);
    }

    // Public API
    getCount() {
      return this.getWishlist().length;
    }

    getItems() {
      return this.getWishlist();
    }

    clear() {
      this.saveWishlist([]);
      this.updateAllButtons();
    }
  }

  // Initialize wishlist
  const wishlist = new Wishlist();

  // Make it globally accessible
  window.Wishlist = wishlist;

  // Add CSS for notification (only once)
  if (!document.getElementById('wishlist-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'wishlist-notification-styles';
    style.textContent = `
      .wishlist-notification {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #333;
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.3s ease;
        font-size: 14px;
      }

      .wishlist-notification.show {
        opacity: 1;
        transform: translateY(0);
      }

      @media (max-width: 768px) {
        .wishlist-notification {
          bottom: 80px;
          right: 16px;
          left: 16px;
          text-align: center;
        }
      }
    `;
    document.head.appendChild(style);
  }
})();
